query AssignmentScheduleInstances(
  $scenarioId: ID!
  $originId: ID!
  $filter: ScheduleInstanceFilterInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    scheduleInstances(filter: $filter) {
      date
      day
      startingTime
      endingTime
      interval {
        id
        name
        startingDate
        endingDate
      }
      sections {
        id
        code
        component {
          id
          code
          name
        }
        sessions {
          id
          blocksCount
          blocks {
            id
            day
            startingTime
            endingTime
          }
          classrooms {
            id
            code
            name
            classroomType {
              id
              code
              name
            }
            building {
              id
              code
              name
              campus {
                id
                code
                name
              }
            }
            floor
            usable
          }
          instructors {
            id
            code
            name
          }
        }
      }
    }
  }
}
